var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___WUNkTm",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___WUNkTm",
  "Se": "ChannelAttachmentArea.module__upload___WUNkTm",
  "PO": "ChannelAttachmentArea.module__uploadContainer___WUNkTm",
  "il": "ChannelAttachmentArea.module__mediaContainer___WUNkTm",
  "BA": "ChannelAttachmentArea.module__clickableMedia___WUNkTm",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___WUNkTm",
  "R": "ChannelAttachmentArea.module__hidden___WUNkTm",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___WUNkTm",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___WUNkTm",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___WUNkTm",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___WUNkTm",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___WUNkTm",
  "p6": "ChannelAttachmentArea.module__spoiler___WUNkTm",
  "$_": "ChannelAttachmentArea.module__media___WUNkTm",
  "_A": "ChannelAttachmentArea.module__tags___WUNkTm",
  "H6": "ChannelAttachmentArea.module__filenameContainer___WUNkTm",
  "iW": "ChannelAttachmentArea.module__filename___WUNkTm",
  "VF": "ChannelAttachmentArea.module__fileDetails___WUNkTm",
  "Ov": "ChannelAttachmentArea.module__fileSize___WUNkTm",
  "i_": "ChannelAttachmentArea.module__fileExtension___WUNkTm",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___WUNkTm",
  "KY": "ChannelAttachmentArea.module__actionBar___WUNkTm" + " " + __webpack_require__(377561)["KE"],
  "x6": "ChannelAttachmentArea.module__button___WUNkTm" + " " + __webpack_require__(377561)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___WUNkTm",
  "le": "ChannelAttachmentArea.module__actionBarIcon___WUNkTm",
  "s3": "ChannelAttachmentArea.module__altTag___WUNkTm",
  "Kk": "ChannelAttachmentArea.module__icon___WUNkTm",
  "Dp": "ChannelAttachmentArea.module__iconImage___WUNkTm",
  "vt": "ChannelAttachmentArea.module__videoModal___WUNkTm",
  "j": "ChannelAttachmentArea.module__videoContainer___WUNkTm",
  "yF": "ChannelAttachmentArea.module__divider___WUNkTm",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___WUNkTm",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___WUNkTm",
};

module.exports = exports;
